// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xngAddAccount } from "@flip/App/Services/AccountService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    stopWatchingForOtherTabSessionChange,
    watchForOtherTabSessionChange,
} from "@insite/client-framework/Services/SessionService";
import {
    AddAccount,
    AddAccountParameter,
    chain,
} from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";

export interface XngAddAccountParameter extends AddAccountParameter {
    FirstName: string;
    LastName: string;
    Email: string;
    PhoneNumber: string;
    CompanyName: string;
    NewCustomer: string;
    Website: string;
    BusinessType: string;
    MarketSpace: string;
    MainContactFirstName: string;
    MainContactLastName: string;
    MainContactEmail: string;
    MainContactPhoneNumber: string;
    BAddress1: string;
    BAddress2: string;
    BCountry: string;
    BState: string;
    BCity: string;
    BPostalCode: string;
    FinanceContactName: string;
    FinancePhoneNumber: string;
    FinanceContactEmail: string;
    UseBillingAddressForShipping: string;
    SAddress1: string;
    SAddress2: string;
    SCountry: string;
    SState: string;
    SCity: string;
    SPostalCode: string;
    onSuccess?: () => void;
    onError?: (error: string) => void;
}

export const XngAddAccount: typeof AddAccount = async props => {
    stopWatchingForOtherTabSessionChange();
    props.apiResult = await xngAddAccount(props.apiParameter);
    watchForOtherTabSessionChange();
};

replaceInChain(chain, AddAccount, XngAddAccount);
